import React, { useState, useEffect } from "react";
import { Formik, Field, FormikActions } from "formik";
import { connect } from "react-redux";
import { required, isEmail, isPhone } from "utils/formValidators";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import Slider from "react-slick";
import UserAvatar from "react-user-avatar";
import moment from "moment";
import cn from "classnames";
import { USER_ROLES } from 'enums/userRoles';

import TextField from "components/TextField";
import LoadAvatar from "./components/LoadAvatar";
import Notifications from "./components/Notifications";

import { IRootState } from "reducers";
import { IUserData } from "reducers/user";
import { Actions } from "reducers/user";

import * as referalsAPI from "api/referals";
import * as notificationsAPI from "api/notifications";
import * as profileAPI from "api/regRequest";

interface IProps {
  user: IUserData;
  updateProfile: any;
}

const ProfilePage: React.SFC<IProps> = ({ user, updateProfile }) => {
  const [isEdit, setEdit] = useState(false);
  const [isCopied, setCopied] = useState(false);
  const [referals, setReferals] = useState<any>([]);
  const [passwordError, setPasswordError] = useState(false);
  const [notifications, setNotifications] = useState<any | undefined>(
    undefined
  );
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordRepeat, setNewPasswordRepeat] = useState<string>("");

  const sliderSettings = {
    slidesToShow: referals.length > 7 ? 7 : referals.length,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: referals.length > 6 ? 6 : referals.length,
          slidesToScroll: 1,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: referals.length > 5 ? 5 : referals.length,
          slidesToScroll: 1,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: referals.length > 6 ? 6 : referals.length,
          slidesToScroll: 1,
          swipeToSlide: true
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: referals.length > 5 ? 5 : referals.length,
          slidesToScroll: 1,
          swipeToSlide: true
        }
      }
    ]
  };

  const getNotifications = () => {
    notificationsAPI.getSelectedNotifications().then((response: any) => {
      if (response.success) {
        console.log("ув", response.success);
        setNotifications(response.data);
      } else {
        toastr.error("Ошибка получения выбранных уведомлений", response.error);
      }
    });
  };

  useEffect(() => {
    referalsAPI.getReferals().then((response: any) => {
      if (response.success) {
        setReferals(response.data);
      } else {
        toastr.error("Ошибка получения данных", response.error);
      }
    });
    getNotifications();
  }, []);

  const handleEditProfile = () => {
    setEdit(!isEdit);
  };

  const submit = (
    values: IUserData,
    { setSubmitting, setStatus }: FormikActions<IUserData>
  ) => {
    updateProfile(values, setSubmitting, handleEditProfile);
  };

  const refLink = `
    ${document.location!.origin}
    ${user.role_id === USER_ROLES.CAR_AGENT ? '/auth/registration' : '/auth/checkIn'}
    ?ref=${user.referalCode}
  `;

  const handleCopy = () => {
    setCopied(true);
  };

  const handleChangeNotifications = (
    type_no: number,
    email: boolean,
    sms: boolean
  ) => {
    notificationsAPI
      .updateNotifications({ type_no, email, sms })
      .then((response: any) => {
        if (response.success) {
          getNotifications();
          toastr.success("Уведомление успешно изменено", "");
        } else {
          toastr.error("Ошибка измеения уведомления", response.error);
        }
      });
  };

  const refEndDate = moment(user.ref_end_date)
    .utc()
    .format("YYYY-MM-DD");
  const todayDate = moment(new Date()).format("YYYY-MM-DD");

  const handleChangeNewPassword = (value: any) => {
    setNewPassword(value);
  };

  const handleChangePassword = () => {
    if (newPassword !== newPasswordRepeat) {
      toastr.error("Введенные пароли не совпадают", "");
      setPasswordError(true);
    } else {
      if (/[A-Z]/.test(newPassword) && newPassword.length > 7 && /[a-z]/.test(newPassword)){
        profileAPI
          .changePassword({ newpass: newPassword })
          .then((response: any) => {
            if (response.success) {
              setPasswordError(false);
              toastr.success("Пароль успешно изменен", "");
            } else {
              setPasswordError(false);
              toastr.error(
                "Не смогли изменить пароль. Нажмите Ctrl+F5 и попробуйте повторно. В случае проблемы обратитесь в поддержку ",
                response.error
              );
            }
          });
      } else{
        toastr.error(
          "Пароль не отвечает требованиям безопасности: минимальная длина 8 символов, наличие букв разного регистра",
          ""
        );
        setPasswordError(true);
      }
    }
  };
  console.log('pe', passwordError);
  return (
    <React.Fragment>
      <div className="container bug_1200 profile-page">
        <div className="row bug_1200_row">
          <div className="col-12 col-lg-7 mb-3 mb-lg-0 xx______">
            <div className="prof">
              <Formik
                initialValues={user}
                onSubmit={submit}
                render={({ errors, handleReset, isSubmitting, submitForm }) => (
                  <React.Fragment>
                    <div className="row d-flex justify-content-between align-items-center no-gutters w-100 mb-4 ">
                      {moment(refEndDate)
                        .utc()
                        .isAfter(todayDate) ? (
                        <div className="referal-bonus-notification">{`У вас действует повышенный процент  ещё ${moment(
                          user.ref_end_date
                        ).diff(moment(new Date()), "days")} дней`}</div>
                      ) : null}
                      <h2 className="prof__title">Профиль</h2>
                      {!isEdit ? (
                        <a
                          className="prof__edit btn_edit___ "
                          onClick={handleEditProfile}
                        >
                          Редактировать
                        </a>
                      ) : (
                        <div className="edit__buttons flex____ justify-content-between col-12 col-md-6 option_edit___">
                          <button
                            className="btn btn-grey px-0 py-0 profile-btn-border"
                            onClick={() => {
                              handleReset();
                              handleEditProfile();
                            }}
                            disabled={isSubmitting}
                          >
                            Отменить
                          </button>
                          <button
                            className=" ml-2 btn px-0 py-0 profile-btn-border"
                            disabled={isSubmitting}
                            onClick={submitForm}
                          >
                            Сохранить
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <Field
                        name="photo"
                        isEdit={isEdit}
                        component={LoadAvatar}
                      />
                      <div className="col-12 col-md-6">
                        <div className="form-row mb-4">
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              name="second_name"
                              placeholder="Фамилия"
                              readOnly={!isEdit}
                              validate={required}
                            />
                          </div>
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              name="first_name"
                              placeholder="Имя"
                              readOnly={!isEdit}
                              validate={required}
                            />
                          </div>
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              name="patronymic"
                              placeholder="Отчество"
                              readOnly={!isEdit}
                              validate={required}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-row mb-2">
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              name="phonenumber"
                              placeholder="Номер телефона"
                              readOnly={!isEdit}
                              validate={isPhone}
                              mask="+7 (999) 999-99-99"
                            />
                          </div>
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              placeholder="Компания"
                              name="company"
                              readOnly={!isEdit}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-row mb-2">
                          <div className="form-group w-100 mb-0 trigger_______">
                            <Field
                              component={TextField}
                              readOnly={!isEdit}
                              name="email"
                              validate={isEmail}
                              placeholder="E-mail"
                            />
                          </div>
                          <div className="form-group w-100 mb-0  trigger_______">
                            <Field
                              component={TextField}
                              readOnly={!isEdit}
                              name="position"
                              placeholder="Должность"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group mb-0 trigger_______  form-row">
                          <label htmlFor="#input8">
                            Регион проживания/ведения деятельности:
                          </label>
                          <Field
                            className="mb-0"
                            component={TextField}
                            id="input8"
                            name="city"
                            readOnly={true}
                            autocomplete={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="change-password">
                      <div className="change-password__title">Смена пароля</div>
                      <div className="change-password__block">
                        <div className="change-password__block-input">
                          <div className="form-group w-100 mb-0  trigger_______  form-row">
                            <input
                            className={cn({"input-error": passwordError})}
                              placeholder="Новый пароль"
                              type="password"
                              value={newPassword}
                              onChange={e =>
                                handleChangeNewPassword(e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group w-100 mb-0  trigger_______  form-row">
                            <input
                              className={cn({"input-error": passwordError})}
                              placeholder="Новый пароль повторно"
                              type="password"
                              value={newPasswordRepeat}
                              onChange={e =>
                                setNewPasswordRepeat(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="change-password__block-btn">
                          <div className="change-password__block-hint">
                            Минимальная длина 8 символов и наличие заглавных
                            букв
                          </div>
                          <button
                            className="btn"
                            onClick={handleChangePassword}
                          >
                            Сменить пароль
                          </button>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              />
            </div>
          </div>
          <div className="col-12 col-lg-5 xx______">
            <div className="row no-gutters">
              <div className="col-12 col-md-6 col-lg-12 pr-md-2 pr-lg-0">
                <div className="ref">
                  <div className="row d-flex justify-content-between align-items-center no-gutters mb-2 mb-lg-3">
                    <h2 className="prof__title">
                      Реферальная
                      <br className="d-lg-none" /> программа
                    </h2>
                    <Link to="/home/referal" className="prof__edit text-center">
                      Подробнее
                    </Link>
                    <div className="col-12 d-lg-none">
                      <hr className="my-2" />
                    </div>
                  </div>
                  <button className="btn empty-btn p-0 d-none">
                    <strong>Реферальная программа</strong>
                    <br />
                    <span>
                  Пригласи друга и зарабатывай
                  <span className="d-block d-lg-none" /> с его продаж
                </span>
                  </button>
                  <div className="row mx-0 w-100">
                    <div className="slider__title d-flex ">
                      <p>Моя команда</p>
                      <span>/ {referals.length} чел.</span>
                    </div>
                    <div className="slider w-100 d-flex slider-profile-referals">
                      <Slider {...sliderSettings}>
                        {referals.length ?
                          <React.Fragment>
                            {referals.map((item: any, index: number) => (
                              <div key={`item-${index}`}>
                                <UserAvatar
                                  size="43px"
                                  name={`${item.first_name} ${item.second_name}`}
                                  src={item.photo}
                                />
                              </div>
                            ))}
                          </React.Fragment>
                          : null
                        }
                      </Slider>
                    </div>
                  </div>
                  <div className="row no-gutters justify-content-between align-items-center mt-lg-3">
                    <span className="ref__my">Моя реферальная ссылка:</span>
                    <CopyToClipboard text={refLink} onCopy={handleCopy}>
                      <button className="ref__btn btn">
                        {isCopied ? "Скопировано" : "Скопировать ссылку"}
                      </button>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-12 pl-md-2 pl-lg-0">
                <div className="notif mb-0">
                  <div className="row d-flex justify-content-between align-items-center no-gutters mb-2">
                    <h2 className="prof__title">Уведомления</h2>
                    <Link
                      to={"/home/notifications"}
                      className="prof__edit text-center"
                    >
                      Все уведомления
                    </Link>
                    <div className="col-12 d-lg-none">
                      <hr className="my-2" />
                    </div>
                  </div>
                  {notifications &&
                    notifications
                      .slice(0, 2)
                      .map((item: any, index: number) => (
                        <Notifications
                          {...item}
                          key={`${item.id} ${index}`}
                          onHandleChange={handleChangeNotifications}
                        />
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user }: IRootState) => ({
  user
});

const actions = {
  updateProfile: Actions.updateProfile
};

export default connect(
  mapStateToProps,
  actions
)(ProfilePage);
